// extracted by mini-css-extract-plugin
module.exports = {"list":"SkipMenu-list-2GqBB","item":"SkipMenu-item-31jhp"};